import {TableDataFetcher} from "./TableDataFetcher";
import {TableModel} from "../model/TableModel";
import { format } from 'date-fns'
import HttpClient from "./HttpClient";
import OrgCmd from "../model/jcr/OrgCmd";


const NAME_COLUMN = 0;
const CREATED_DATE_COLUMN = 1;
const MODIFIED_DATE_COLUMN = 2;
const STATUS_COLUMN = 3;
const OPTION_COLUMN = 4;
const TOTAL_COLUMN = 5;

export class ViewDataFetcher implements TableDataFetcher {
    private data: any;
    private allData: any;
    private duplicateNames: Set<string>;
    private searchTerm: string = "";

    constructor(private currentOrg:OrgCmd, private cleanHistory: () => void , searchTerm: string) {
        this.duplicateNames = new Set<string>();
        this.searchTerm = searchTerm;
    }

    setSearchTerm(value: string) : ViewDataFetcher {
        this.searchTerm = value;
        if(value === "") {
            this.data = this.allData;
        } else {
            // this.data = this.allData;
            //
            this.data = this.allData.filter((object:any) => object.viewName.toLowerCase().indexOf(value.toLowerCase()) >= 0);
        }
        return this;
    }

    canDelete(): boolean {
        return false;
    }

    getItemAt(row: number): any {
        return this.data[row];
    }

    findDataById(id: string): any {
        if(this.data === null) return;
        for(let i=0;this.data.length;i++) {
            if(this.data[i].id === id) {
                return this.data[i];
            }
        }
        return null;
    }

    load() : Promise<any> | null {
        return HttpClient.get("/api/v0/jcr/org/" + this.currentOrg.orgCode + "/lite/views").then((result) => {
            this.allData = result.data.response;
            if(this.searchTerm === "") {
                this.data = this.allData;
            } else {
                this.data = this.allData.filter((object:any) => object.viewName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0);
            }

            let allNames = new Set<string>();
            this.data.forEach((item:any) => {
                let name = item.viewName;
                if(allNames.has(name)) {
                    this.duplicateNames.add(name);
                } else {
                    allNames.add(name);
                }
            });
        });
    }

    getIdAt(row: number): string {
        return this.data[row].id;
    }

    getColumnAlignAt(col: number): ("left" | "right" | "center") {
        if(col === NAME_COLUMN) return "left";
        else if(col === CREATED_DATE_COLUMN) return "right";
        else if(col === OPTION_COLUMN) return "center";
        else return "right";
    }

    getDataAt(row: number, col: number): TableModel {
        let item = this.data[row];
        if(col === NAME_COLUMN) {
            return new TableModel(item.id,
                item.viewName,
                "",
                "/pages/" + item.viewName + "/" + item.id,
                this.cleanHistory);
        } else if(col === CREATED_DATE_COLUMN) {
            return new TableModel(item.id,
                format(new Date(item.viewCreatedAt),  'yyyy/MM/dd'),"");
        } else if(col === MODIFIED_DATE_COLUMN) {
            return new TableModel(item.id,
                format(new Date(item.viewModifiedAt),  'yyyy/MM/dd'),"");
        } else if(col === STATUS_COLUMN) {
            return new TableModel(item.id,
                "Publish","",);
        } else if(col === OPTION_COLUMN) {
            return new TableModel(item.id,
                "Rename",
                "",
                "/pages/" + item.id,
                this.cleanHistory,
                [
                    { icon: "visibility", label: "Preview", pathname: "/pages/" + item.viewName + "/" + item.id , search: {view: true}},
                    { icon: "edit", label: "Edit", pathname: "/pages/" + item.viewName + "/" + item.id , search: null},
                    { icon: "edit_note", label: "Rename", pathname: "/pages/" + item.id , search: null},
                    { icon: "content_copy", label: "Duplicate", pathname: "/pages/" + item.id , search: null, action: { tag: "DUPLICATE", tagObject: item } },
                    { icon: "download", label: "Download", pathname: "/pages/" + item.id , search: null, action: { tag: "DOWNLOAD", tagObject: item }},
                ]);
        } else {
            return new TableModel("",
                "","",);
        }
    }

    getTotalRecords(): number {
        if(this.data && this.data !== null) {
            return this.data.length;
        } else {
            return 0;
        }
    }

    getColumnNameAt(col: number): string {
        if(col === NAME_COLUMN) {
            return "Page Name";
        } else if(col === CREATED_DATE_COLUMN) {
            return "Create Date"
        } else if(col === MODIFIED_DATE_COLUMN) {
            return "Modified Date"
        } else if(col === STATUS_COLUMN) {
            return "Status"
        } else if(col === OPTION_COLUMN) {
            return "Options"
        } else {
            return "";
        }
    }

    getNumberOfColumns(): number {
        return TOTAL_COLUMN;
    }



}